import { createMuiTheme } from '@material-ui/core';
import { createContext, useContext, useState } from 'react';
import { colors } from '../colors';

const ThemeContext = createContext();

export function ThemeContextProvider({ children }) {
  const [themeColor, setThemeColor] = useState({primary: colors.default, secondary: "#fff"});
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: themeColor.primary,
      },
      secondary: {
        main: themeColor.secondary,
      },
      text: {
        primary: colors.darkDefault,
        secondary: colors.darkOrange,
      }
    },
    typography: {
      fontFamily: ["Roboto", "sans-serif"],
      h1: {
        fontSize: '2rem',
        fontWeight: 700,
      },
      h2: {
        fontSize: '2rem',
        fontWeight: 700,
      }
    },
    overrides: {
      MuiMenuItem: {
        root: {
          whiteSpace: "normal"
        },
      },
    },
  });

  const changeTheme = (redeId) => {
    switch(redeId) {
      case "1":
        return setThemeColor({primary: colors.orange, secondary: "#fff"});
      case "2":
        return setThemeColor({primary: colors.turquoise, secondary: colors.darkOrange});
      case "3":
        return setThemeColor({primary: colors.emerald, secondary: "#fff"});
      case "4":
        return setThemeColor({primary: colors.pink, secondary: "#fff"});
      case "5":
        return setThemeColor({primary: colors.blue, secondary: "#fff"});
      default:
        return setThemeColor({primary: colors.default, secondary: colors.darkOrange});
    }
  }

  return (
    <ThemeContext.Provider 
      value={{
        theme,
        changeTheme,
        themeColor,
      }
    }>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => {
  return useContext(ThemeContext);
}